import React, { useState, useEffect } from "react";
import { useParams } from "@reach/router";
import { Helmet } from "react-helmet";
import { Wrapper, Loader } from "@gw/component-library";
import { useBNDataLayer } from "@gw/bn-data-layer";
import { useEnvContext } from "@gw/env-context";
import { FarmerProfileStyled } from "./FarmerProfileStyled";
import ProfileImage from "./ProfileImage";
import Contact from "./Contact";
import ProfileDetails from "./ProfileDetails";
import ErrorMessage from "../ErrorMessage";
var FarmerProfile = function () {
    var _a = useState(), farmer = _a[0], setFarmer = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), hasError = _c[0], setHasError = _c[1];
    var farmerId = useParams().farmerId;
    var _d = useBNDataLayer(), dataLayerIsReady = _d.isReady, getFarmer = _d.getFarmer;
    var imgsFolder = useEnvContext().imgsFolder;
    useEffect(function () {
        if (dataLayerIsReady) {
            getFarmer(farmerId)
                .then(function (farmer) {
                setFarmer(farmer);
                setIsLoading(false);
            })
                .catch(function () {
                setHasError(true);
                setIsLoading(false);
            });
        }
    }, [farmerId, getFarmer, dataLayerIsReady]);
    return (React.createElement(FarmerProfileStyled, null, isLoading ? (React.createElement(Loader, null)) : hasError || !farmer ? (React.createElement(ErrorMessage, { message: "There was an error when loading this farmer profile." })) : (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("title", null,
                "Seaweed Source - ",
                farmer.name)),
        React.createElement(Wrapper, { className: "farmer-profile-wrapper" },
            React.createElement("div", { className: "farmer-profile-background" },
                React.createElement(ProfileImage, { className: "farmer-profile-image", name: farmer.name, image: farmer.logo_img_url }),
                React.createElement(Contact, { id: "" + farmer.id, city: farmer.city, state: farmer.state, website_url: farmer.website_url, contact_email: farmer.contact_email, twitter: farmer.twitter, instagram: farmer.instagram, facebook: farmer.facebook, size: "" + farmer.size })),
            React.createElement(ProfileDetails, { summary: farmer.summary, species_data: farmer.species_data, founded: farmer.founded }))))));
};
export default FarmerProfile;
//# sourceMappingURL=FarmerProfile.js.map